
import React from 'react'
// import { ContactForm } from './Contactform';
// import img1 from '../../Images/icons/add.png';
// import img2 from '../../Images/icons/email.png';
// import img3 from '../../Images/icons/phone.png';
// import location from '../../Images/icons/pin.png'
// import { Link } from 'react-router-dom';
// import Fade from 'react-reveal/Fade';
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';


const ContactDetails = () => {
    return (
        <>
            <section id="contact" className='contact' >
                <div className='contact_intro_sec' >
                    <>
                        <h1 style={{ color: "gold" }}> Get in touch</h1>
                    </>
                </div>
                {/* Contact Section */}
                <section className="text-white py-5" style={{backgroundColor:"#143D53"}}>
                    <Container>
                        {/* <h2 className="text-center mb-4">Contact Us</h2> */}
                        <Row className="gy-4 justify-content-center">

                            {/* Location */}
                            <Col md={4}>
                                <Card className="h-100 text-center border-0 shadow-sm" style={{backgroundColor:"#0F2C3C"}}>
                                    <Card.Body>
                                        <FaMapMarkerAlt className="display-4 mb-3" style={{color:"gold"}} />
                                        <Card.Title className='text-white'>Location</Card.Title>
                                        <Card.Text className='text-white text-center text-sm'>
                                            Sector 125, Noida, Uttar Pradesh(India), Pin: 201313
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Phone */}
                            <Col md={4}>
                                <Card className="h-100 text-center border-0 shadow-sm" style={{backgroundColor:"#0F2C3C"}}>
                                    <Card.Body>
                                        <FaPhoneAlt className="display-4 text-primary mb-3" style={{color:"gold"}} />
                                        <Card.Title className='text-white text-center text-sm'>Phone</Card.Title>
                                        <Card.Text className='text-white text-center text-sm'>+91 98999 95055</Card.Text>
                                        <Card.Text className='text-white text-center text-sm'>+91 83830 66383</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* Email */}
                            <Col md={4}>
                                <Card className="h-100 text-center border-0 shadow-sm" style={{backgroundColor:"#0F2C3C"}}>
                                    <Card.Body>
                                        <FaEnvelope className="display-4 text-primary mb-3" style={{color:"gold"}} />
                                        <Card.Title className='text-white text-center text-sm'>Email</Card.Title>
                                        <Card.Text className='text-white text-center text-sm'>Anjani.kb@gmail.com</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Map Section */}
                <div className='map'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7009.648690906065!2d77.32721094112672!3d28.54499900285018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce42adeaa3eab%3A0xc2d9de2512046747!2sSector%20125%2C%20Noida%2C%20Uttar%20Pradesh%20201313!5e0!3m2!1sen!2sin!4v1735378918552!5m2!1sen!2sin"
                        title='Amity Technical Placement Centre'
                        width="800"
                        height="600"
                        style={{ border: 0 }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"></iframe>  
                </div>
                <div />
            </section>
        </>
    )
}

export default ContactDetails
